module.exports = __webpack_public_path__ + "static/media/arrows-shrink-h.6d488af8.svg";